import format from 'date-fns/format'
import parseISO from 'date-fns/parseISO'

export const formatGroupEventSessionLine = sessions => {
  const session = sessions?.[0]
  if (!session?.startDateTime) return null

  const start = parseISO(session.startDateTime)
  const end = session.endDateTime ? parseISO(session.endDateTime) : null
  const datePart = format(start, 'EEE, MMMM d')

  if (!end) {
    return `${datePart} • ${format(start, 'h:mm a')}`
  }

  const endMeridiem = format(end, 'a')
  const startMeridiem = format(start, 'a')
  const timePart =
    startMeridiem === endMeridiem
      ? `${format(start, 'h:mm')} - ${format(end, 'h:mm a')}`
      : `${format(start, 'h:mm a')} - ${format(end, 'h:mm a')}`

  return `${datePart} • ${timePart}`
}

export const formatLessonTypeDetailLine = lessonType => {
  if (!lessonType) return null

  const facilityName =
    lessonType.facilities?.[0]?.name || lessonType.locations?.[0]?.name

  if (facilityName && lessonType.durationInMinutes) {
    return `${facilityName} • ${lessonType.durationInMinutes} min`
  }

  if (facilityName) return facilityName
  if (lessonType.coach?.name) return `Coach ${lessonType.coach.name}`
  if (lessonType.durationInMinutes) {
    return `${lessonType.durationInMinutes} min`
  }

  return null
}
